<div class="flex h-full w-full items-center justify-center">
  <div class="relative h-[85vh] w-screen max-w-4xl p-4">
    <div class="relative flex h-full flex-col rounded-lg bg-white shadow">
      <div
        class="flex items-center justify-between gap-4 rounded-t border-b border-gray-200 p-4 sm:p-5">
        <h3 class="min-w-0 truncate text-xl font-bold text-gray-900">
          {{ data.name }}
        </h3>
        <button
          type="button"
          aria-label="Close preview"
          class="inline-flex shrink-0 rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900"
          (click)="close()">
          <svg
            aria-hidden="true"
            class="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>

      <div class="min-h-0 flex-1 p-4 sm:p-5">
        @if (loading()) {
          <div class="flex h-full items-center justify-center">
            <icaredx-spinner size="large" />
          </div>
        } @else if (error()) {
          <div
            class="flex h-full flex-col items-center justify-center gap-2 text-center text-gray-500">
            <mat-icon
              svgIcon="alert-circle-outline"
              class="h-10! w-10! text-red-500"></mat-icon>
            <p class="text-sm font-medium">
              We couldn’t load this file. Please try again later.
            </p>
          </div>
        } @else if (isImage() && imageUrl()) {
          <div
            class="flex h-full w-full items-center justify-center overflow-auto rounded-lg border border-gray-200 bg-gray-50">
            <img
              [src]="imageUrl()"
              [alt]="data.name"
              class="max-h-full max-w-full object-contain" />
          </div>
        } @else if (src()) {
          <iframe
            [src]="src()"
            type="application/pdf"
            class="h-full w-full rounded-lg border border-gray-200"
            title="Document preview"></iframe>
        }
      </div>

      <div
        class="flex items-center justify-center gap-x-4 border-t border-gray-200 p-4 sm:p-5">
        <icaredx-button color="secondary" (clicked)="close()">
          <span class="px-5">Close</span>
        </icaredx-button>
        <icaredx-button
          color="secondary"
          svgIcon="download-outline"
          [disabled]="loading() || error()"
          (clicked)="download()">
          <span class="px-2">Download</span>
        </icaredx-button>
      </div>
    </div>
  </div>
</div>
